<template>
  <div id="breadcrumb-wrapper" :class="{'with-parents': showParents }">
  <Breadcrumb
    :id="mapObject.id"
    :name="nameLabel"
    :type="typeLabel"
    :showBackButton="true"
    @backButtonPressed="clickBack"
  >
<!--    <template v-if="showParents" v-slot:parents>-->
<!--    </template>-->
    <template v-slot:icon>
      <IconByTypeId
        v-if="mapObject.map_object_type_id"
        :map_object_type_id="mapObject.map_object_type_id"
        :label="mapObject | mapObjectLabel"
        :size="39"
      />
    </template>
  </Breadcrumb>
  <BreadcrumbParents v-if="showParents" :parents="parents" @clickParent="clickParent" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import IconByTypeId from '@/components/IconByTypeId.vue';
import Breadcrumb from '@/components/Layout/Breadcrumb.vue';
import BreadcrumbParents from '@/components/Layout/BreadcrumbParents.vue';

import NetworkIcon from '@/enums/NetworkIcon';

import * as dataCache from '@/store/cache/dataCache';

export default {
  name: 'BreadcrumbMapObject',
  components: {
    BreadcrumbParents,
    Breadcrumb,
    IconByTypeId,
  },
  props: {
    mapObject: {
      type: Object,
      required: true,
      default: null,
    },
    extraLabel: {
      type: String,
      required: false,
      default: '',
    },
    showBackButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    showParents: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      networkIcon: NetworkIcon,
    };
  },
  computed: {
    ...mapGetters({
      mapObjectTypes: 'settings/getMapObjectTypes',
      network: 'settings/getNetworkModel',
      keyValues: 'settings/getKeyValues',
    }),
    nameLabel() {
      return `${this.$options.filters.mapObjectLabel(this.mapObject)} ${this.extraLabel}`;
    },
    typeLabel() {
      if (!this.mapObjectTypes) {
        return '';
      }
      if (!this.mapObject) {
        return '';
      }
      if (!this.mapObjectTypes[this.mapObject.map_object_type_id]) {
        return '';
      }
      return this.mapObjectTypes[this.mapObject.map_object_type_id].name;
    },
    parents() {
      const parents = dataCache.getParentsForMapObjectId(this.mapObject.id);
      return parents.reverse();
    },
  },
  methods: {
    clickBack() {
      if (this.parents.length > 0) {
        this.$emit('clickBack', 'map_object', this.parents[this.parents.length - 1].id);
      } else {
        this.$emit('clickBack', 'network', this.network.id);
      }
    },
    clickParent(model, id) {
      this.$emit('clickParent', model, id);
    },
  },
};
</script>

<style scoped>
div#breadcrumb-wrapper.with-parents {
  margin-bottom: -22px
}
</style>
